import { render, staticRenderFns } from "./order-pay.vue?vue&type=template&id=7a50a14c&"
import script from "./order-pay.vue?vue&type=script&lang=js&"
export * from "./order-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports